/**
 * Pronto Posto – Maildaten · Französisch (fr-FR) · KS03
 *
 * KS03 Croisière de rêve – Petra Witzgold / Rafaela Silva. Postfach: silva.rafaela@pronto-posto.com
 *
 * Aufteilung nach language/episode: geteilte Inhalte einer Sprache leben in ./_shared.js.
 * Sprachen sind strikt getrennt – Mails dieser Datei adressieren ausschliesslich Postfaecher
 * dieser Sprache. IDs sind global eindeutig (siehe ID-Reservierungen in den Blockkommentaren).
 *
 * LOKALER KANDIDAT (KI-Übersetzung, intern reviewbar) – keine Agentur-/Native-Freigabe.
 * Petra Witzgold / p.witzgold@ bewusst unverändert: keine FR-Namensentscheidung im Glossar
 * (siehe QUESTIONS.json, FR-WEB-Q01).
 */
/* eslint-disable */

export function getEmails() {
    return [
        // KS03 Traumschiff Rework: Petra – Rafaela Mails — FR
        // (Rafaela-Silva-Account: silva.rafaela@pronto-posto.com; Login silva.rafaela / 3009Conrad)
        // Gleiches Muster wie die KS04-Sprachblöcke: eigener Datensatz je Sprache, eigene IDs,
        // Zeitstempel und Rätselwerte 1:1 aus dem DE-Satz. ID-Reservierung KS03:
        // DE 15–19 · EN 70–74 · FR 75–79 · IT 80–84 · ES 85–89.
        {
            id: 75,
            from: {
                email: 'p.witzgold@pronto-posto.com',
                name: 'Petra W',
                avatar: require('@src/assets/images/portrait/petra.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'silva.rafaela@pronto-posto.com'
            }],
            subject: 'St. Helen – un nouveau sujet ?',
            cc: [],
            bcc: [],
            message: 'Salut Rafaela,<p>J’ai entendu au boulot que ton fiancé avait gagné des billets pour le <b>St. Helen</b>.<br><br>Tu te souviens de l’article sur Delorme sur lequel je travaillais il y a peu ?<br>Relis-le… Tu ne vas pas me croire, mais à l’époque, pendant mes recherches, je suis aussi tombée sur le nom de <b>Julien Hoffmann</b>.<br><br>Et tu sais qui c’est ? <b>LE capitaine du St. Helen.</b><br><br>Jette un œil à l’<b>Atlantic Academy</b>. C’est l’école où le capitaine prétend avoir fait ses études…<br><br>Je ne vais pas te dire de travailler pendant tes vacances, mais ÇA, ce serait un article en or.<br><br>Je t’aiderai volontiers, autant que je peux, mais fais bien attention à l’endroit où tu notes tes recherches, et à la manière dont tu le fais. Les gens comme lui sont toujours sur leurs gardes et ont le bras long.<br><br>Je t’embrasse, à demain,<br>Petra',
            attachments: [],
            isStarred: true,
            labels: ['work'],
            time: 'Tue. Jan. 31 2023 15:43:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 76,
            from: {
                email: 'p.witzgold@pronto-posto.com',
                name: 'Petra W',
                avatar: require('@src/assets/images/portrait/petra.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'silva.rafaela@pronto-posto.com'
            }],
            subject: 'Re: Klabautermann ?',
            cc: [],
            bcc: [],
            message: 'Salut Rafaela,<p>Franchement, ton histoire de <b>Klabautermann</b>, le fantôme du navire, ça relève plutôt de la presse people. On ne peut quand même pas publier des histoires de fantômes !<br><br>Tu n’aurais pas plutôt quelque chose sur le capitaine ou sur l’équipage ?',
            attachments: [],
            isStarred: false,
            labels: ['work'],
            time: 'Mon. Mar. 06 2023 10:35:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 77,
                    from: {
                        email: 'silva.rafaela@pronto-posto.com',
                        name: 'Rafaela S',
                        avatar: require('@src/assets/images/portrait/rafaela.png').default
                    },
                    to: [{
                        name: 'Petra W',
                        email: 'p.witzgold@pronto-posto.com'
                    }],
                    subject: 'Klabautermann ?',
                    cc: [],
                    bcc: [],
                    message: 'Salut Petra,<p>Bien sûr que j’ai emporté mon carnet. J’y garde les informations les plus importantes – à l’ancienne. Je l’ai pour ainsi dire toujours sur moi, alors ne t’inquiète pas. Personne n’est près de mettre la main dessus ;) <br><br>Mais tu avais raison, il se passe quelque chose de bizarre sur ce bateau. J’ai pris quelques notes :<br><br><b>Klabautermann ?</b><br>- Petra pense que je ne devrais pas écrire là-dessus, mais je crois qu’il y a autre chose derrière.<br>- Thibault dit : le fantôme loge dans la cabine voisine de la sienne. Une femme aux cheveux foncés se tient toujours dans le couloir et fixe cette cabine, mais elle disparaît dès que quelqu’un arrive. → Quand je lui ai adressé la parole, elle m’a évitée. Qui est-elle ? Elle sait peut-être quelque chose. <br>- Thibault rêve-t-il ? Je ne sais pas si je dois y croire.<br><br><i>Merci de t’inquiéter pour moi, Petra :)</i>',
                    attachments: [],
                    isStarred: false,
                    labels: ['work'],
                    time: 'Sun. Mar. 05 2023 20:24:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },

        {
            id: 78,
            from: {
                email: 'p.witzgold@pronto-posto.com',
                name: 'Petra W',
                avatar: require('@src/assets/images/portrait/petra.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'silva.rafaela@pronto-posto.com'
            }],
            subject: 'Re: Encore quelques notes',
            cc: [],
            bcc: [],
            message: 'Rafaela, sois prudente, je t’en prie ! Laisse tomber si ça devient trop dangereux !',
            attachments: [],
            isStarred: false,
            labels: ['work'],
            time: 'Thu. Mar. 09 2023 08:12:00 GMT+0000 (GMT)',
            replies: [
                {
                    id: 79,
                    from: {
                        email: 'silva.rafaela@pronto-posto.com',
                        name: 'Rafaela S',
                        avatar: require('@src/assets/images/portrait/rafaela.png').default
                    },
                    to: [{
                        name: 'Petra W',
                        email: 'p.witzgold@pronto-posto.com'
                    }],
                    subject: 'Encore quelques notes',
                    cc: [],
                    bcc: [],
                    message: 'Salut Petra,<p>Oui… tu as sans doute raison. L’équipage se comporte bizarrement, lui aussi. Je n’ai encore rien de concret, mais j’ai remarqué deux ou trois choses :<br><br><b>Le capitaine</b><br>- Interview du 08/03, très désagréable, élude mes questions.<br>- www.atlantic-academy.com<br>- L’équipage ne dit pas un mot de travers sur lui, et il les couvre – ils sont tous de mèche (?!)<br>- Pendant l’interview, j’ai réussi à mettre la main sur sa carte. La 01 devrait ouvrir toutes les cabines. J’en ai juste besoin un moment, ensuite je la fais réapparaître. Il ne s’apercevra de rien.<br><br><b>Divers</b><br>- J’ai l’impression de toujours voir quelqu’un quand je quitte ma cabine… est-ce qu’on me suit ?<br>- Romy et Axel ont l’air d’être en couple<br>- Thibault dit que personne ne veut l’aider pour le bruit dans la cabine voisine de la sienne<br>- Axel et Romy demandent de l’argent pour une interview → corruptibles ??<br>- J’ai voulu savoir ce qui se cachait derrière cette femme, et j’ai découvert quelque chose de grave. Il faut que je disparaisse quelque temps, ça devient trop dangereux…<br><br>Il y a encore deux ou trois autres choses, mais celles-là, je préfère ne les noter que sur papier.',
                    attachments: [],
                    isStarred: false,
                    labels: ['work'],
                    time: 'Wed. Mar. 08 2023 21:03:00 GMT+0000 (GMT)',
                    replies: [],
                    folder: 'sent',
                    isRead: true
                }
            ],
            folder: 'inbox',
            isRead: true
        },
    ]
}

export function getSpam() {
    return [
        // KS03 Traumschiff Rework: Rafaela Spam Mails — FR
        // (Rafaela-Silva-Account: silva.rafaela@pronto-posto.com)
        // ID-Reservierung KS03-Spam: DE 107–109 · EN 160–162 · FR 170–172 · IT 180–182 · ES 190–192.

        {
            id: 170,
            from: {
                email: 'offers@instant-crypto.pro',
                name: 'Instant Crypto Offers',
                avatar: require('@src/assets/images/portrait/crypto.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'silva.rafaela@pronto-posto.com'
            }],
            subject: 'EXCLUSIF : gagne 5000 % en 3 jours !',
            cc: [],
            bcc: [],
            message: '<p>Salut,</p><p>Tu as été sélectionné(e) pour notre programme d’investissement secret. Obtiens dès maintenant des rendements élevés en un temps record – à partir de seulement 100 €. Contacte notre équipe pour t’inscrire.</p><br><p>Cordialement,<br>Instant Crypto Offers</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Sat. Feb. 04 2023 12:12:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },

        {
            id: 171,
            from: {
                email: 'funnybiz@monde-merveilleux.fr',
                name: 'Monde Merveilleux FunBiz',
                avatar: require('@src/assets/images/portrait/funbiz.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'silva.rafaela@pronto-posto.com'
            }],
            subject: 'Incroiyable mais vrais !!! 😜',
            cc: [],
            bcc: [],
            message: '<p>Coucou Rafaela,</p><p>Tu va pas le croire, mais on a en ce moment la super-giga Méga Promo du siècle ! 😎<br>Tout ceux qui participent maintenant recoivent des autocollants licorne gratuit + un paquet de bonbons magiques imbatables.</p><p>Alors attend pas trop sinon y en aura plus, et hop, envolé ! 🦄🍬<br>Et chut… dit a personne mon bon plant secret, sinon c’est fini !</p><br><p>Gros bisous rigolos,<br>Ton équipe Monde Merveilleux FunBiz</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Sat. Feb. 25 2023 09:51:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },

        {
            id: 172,
            from: {
                email: 'winner@superlotto-global.com',
                name: 'SuperLotto Global',
                avatar: require('@src/assets/images/portrait/superlotto.png').default
            },
            to: [{
                name: 'Rafaela S',
                email: 'silva.rafaela@pronto-posto.com'
            }],
            subject: 'Vous avez gagné !',
            cc: [],
            bcc: [],
            message: '<p>Félicitations, Rafaela !</p><p>Vous avez été désignée gagnante de notre grand jeu SuperLotto. Pour réclamer votre gain, veuillez contacter notre service client en tenant vos coordonnées à disposition. Votre droit au gain expire dans 48 heures.</p><br><p>L’équipe SuperLotto Global</p>',
            attachments: [],
            isStarred: false,
            labels: ['personal'],
            time: 'Wed. Mar. 01 2023 10:24:00 GMT+0000 (GMT)',
            replies: [],
            folder: 'inbox',
            isRead: false
        },
    ]
}
